function NotFoundPage() {
    return (
      <div style={{ 
      display: "flex", 
      justifyContent: "center", 
      alignItems: "center", 
      height: "100vh", 
      textAlign: "center" 
      }}>
      <div>
        <label>404 Page Not Found</label>
        <br/>
        <label style={{fontSize:'12px', marginTop:'40px'}}> 
        <a href="/monitoring/" style={{ textDecoration: 'underline !important' }}>Back to Home</a>
        </label>
      </div>
      </div>
    );
  }
  
  export default NotFoundPage;
  